module.exports = __webpack_public_path__ + "img/Warrior-undead-m-70.f0bffe65.gif";